<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <legend
    v-if="!!noLegend"
  >
    {{ 'Lessor'|pgettext('Contract') }}
  </legend>
  <ItpFormGroup
    name="company"
    :label="'Company'|pgettext('Contract')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect2
      name="company"
      v-model="contract.company"
      bind-object
      :dataSource="b_1040167445267876_dataSource"
      textField="name"
      prefetch
      required
      optionTemplate="<UcSuggestCompanyOption :option=option></UcSuggestCompanyOption>"
      use-option-template-for-selected-option
      @optionSelected="evh_1040167445267876_optionSelected($event, {})"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    name="head_office"
    :label="'Head office'|pgettext('Company')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    v-if="contract.company"
  >
    <ItpFormInput
      name="head_office"
      v-model="contract.company.head_office"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="branch_office"
    :label="'Branch office'|pgettext('Company')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    v-if="contract.company"
  >
    <ItpFormInput
      name="branch_office"
      v-model="contract.company.branch_office"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="statistical_code"
    :label="'Statistical code'|pgettext('Company')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    v-if="contract.company"
  >
    <ItpFormInput
      name="statistical_code"
      v-model="contract.company.statistical_code"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="registration_number"
    :label="'Registration number'|pgettext('Company')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    v-if="contract.company"
  >
    <ItpFormInput
      name="registration_number"
      v-model="contract.company.registration_number"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="account_number"
    :label="'Account number'|pgettext('Company')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    v-if="contract.company"
  >
    <ItpFormInput
      name="account_number"
      v-model="contract.company.account_number"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="representative"
    :label="'Representative'|pgettext('Company')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    v-if="contract.company"
  >
    <ItpFormTextarea
      name="representative"
      v-model="contract.company.representative"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetContractCompanyData extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  contract!: object;

  @Watch('contract')
  onContract(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contract")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  noLegend!: boolean;

  @Watch('noLegend')
  onNo_legend(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("noLegend")
  }

  ux!: any;
  b_1040167445267876_dataSource!: any;
  dataMembers = ['ux', 'b_1040167445267876_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
        b_1040167445267876_dataSource: {
          name: "suggest_company",
          parameters: {
            role: "own",
          }
          ,
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_setData_8348_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_1040167445267876_setData_8348, alias=undefined
    return {
      path: "contract.company",
      value: $event.data.response.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async act_1040167445267876_request_8346_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_8346, alias=undefined
    return {
      operation: "read_company",
      parameters: {
        id: $event.data.value.id,
      }
      ,
      headers: {
        accept: "application/vnd.itp.contractparty+json",
      }
      ,
    }
  }

  async evh_1040167445267876_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_optionSelected.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_8344: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_8343: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_1040167445267876_setData_8348: actions.SetDataAction;
    evh_1040167445267876_success_8347: actions.EventHandlerImpl;
    act_1040167445267876_request_8346: actions.RequestAction;
    evh_1040167445267876_optionSelected_8345: actions.EventHandlerImpl;
    evh_1040167445267876_optionSelected: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_8344 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_8343 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_8344,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_8343],
      }
    );
    const act_1040167445267876_setData_8348 = new actions.SetDataAction(
      {
        actionArgs: this.act_1040167445267876_setData_8348_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8347 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_setData_8348,
        event: "success",
        displayName: "setData",
      }
    );
    const act_1040167445267876_request_8346 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_8346_getActionArgs,
        events: [evh_1040167445267876_success_8347],
      }
    );
    const evh_1040167445267876_optionSelected_8345 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_8346,
        event: "optionSelected",
        displayName: "request",
      }
    );
    const evh_1040167445267876_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_optionSelected_8345],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_8344,
      evh_7315092382398562_reload_8343,
      evh_7315092382398562_reload,
      act_1040167445267876_setData_8348,
      evh_1040167445267876_success_8347,
      act_1040167445267876_request_8346,
      evh_1040167445267876_optionSelected_8345,
      evh_1040167445267876_optionSelected,
    }
  }
}

Vue.component("FieldsetContractCompanyData", FieldsetContractCompanyData);

</script>